module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.barChartConfig) ? _c('barChartConfig', {
    attrs: {
      "chart": _vm.chart
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3068100e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/chartConfig.vue
// module id = 1811
// module chunks = 2